import React from "react";
import comingSoon from "../../images/coming soon.jpg";
const Blogs = () => {
  return (
    <div>
      <img src={comingSoon} alt="" />
    </div>
  );
};

export default Blogs;
